import React from 'react'

export default function MenuStyle({signed_in}) {
  let menu = {
    dashboard: 'flex',
    products: 'flex',
    stockin: 'flex',
    stockout: 'flex',
    invoice: 'flex',
    receipts: 'flex',
    customers_accounts: 'flex',
    reports: 'flex',
    utilities: 'flex',
    settings: 'flex',
    help: 'flex',
  }
  if (signed_in !== 'admin') {
    menu.dashboard = signed_in.user_access['dashboard'] ? 'flex' : 'none'
    menu.products = signed_in.user_access['products'] ? 'flex' : 'none'
    menu.stockin = signed_in.user_access['stockin'] ? 'flex' : 'none'
    menu.stockout = signed_in.user_access['stockout'] ? 'flex' : 'none'
    menu.invoice = signed_in.user_access['invoice'] ? 'flex' : 'none'
    menu.receipts = signed_in.user_access['receipts'] ? 'flex' : 'none'
    menu.customers_accounts = signed_in.user_access['customers_accounts'] ? 'flex' : 'none'

    //menu.reports = signed_in.user_access['reports'] ? 'flex' : 'none'
    menu.reports = signed_in.user_access.reports &&
      (
        (
          signed_in.user_access.reports_sales_reports &&
          (
            signed_in.user_access.reports_sales_reports_daily_sales ||
            signed_in.user_access.reports_sales_reports_monthly_sales ||
            signed_in.user_access.reports_sales_reports_yearly_sales ||
            signed_in.user_access.reports_sales_reports_receivables
          )
        ) ||
        (
          signed_in.user_access.reports_inventory_reports &&
          (
            signed_in.user_access.reports_inventory_reports_products_inventory ||
            signed_in.user_access.reports_inventory_reports_out_of_stocks ||
            signed_in.user_access.reports_inventory_reports_price_list ||
            signed_in.user_access.reports_inventory_reports_products_sold ||
            signed_in.user_access.reports_inventory_reports_unmoving_products ||
            signed_in.user_access.reports_inventory_reports_products_with_exprations
          )
        )
      ) ? 'flex' : 'none'

    //menu.utilities = signed_in.user_access['utilities'] ? 'flex' : 'none'
    menu.utilities = (
      signed_in.user_access.utilities &&
      (
        signed_in.user_access.utilities_purchase_order ||
        signed_in.user_access.utilities_percent_off_batch_set ||
        signed_in.user_access.utilities_reset_percent_off
      )
    ) ? 'flex' : 'none'

    //menu.settings = signed_in.user_access['settings'] ? 'flex' : 'none'
    menu.settings = (
      signed_in.user_access.settings &&
      (
        signed_in.user_access.settings_warehouses ||
        signed_in.user_access.settings_vat ||
        signed_in.user_access.settings_npos_accounts_settings
      )
    ) ? 'flex' : 'none'

    menu.help = signed_in.user_access['help'] ? 'flex' : 'none'

  }

  return (
    <React.Fragment>
      <style jsx="true">
      {`
        .menu-btn-caption { display: flex; }

        .menu-btn-caption .btn-icon {
          padding: 5px;
          margin-right: 2px;
          width: 20px;
        }

        .menu-btn-caption .btn-caption {
          margin: auto;
          min-width: 150px;
          text-align: left;
        }

        #menu {
          background-color: #3c64de;
          grid-area: menu;
          overflow-y: show;
          overflow-x: hidden;
          border-right: solid 1px rgba(200, 200, 200, 1);
          max-width: 250px;
        }

        .menu-list li button {
          background-color: transparent;
          border: none;
          padding: 10px 10px;
          margin-bottom: 1px;
          display: flex;
          justify-content: space-between;
          color: white;
          text-decoration: none;
          font-size: 0.65em;
          height: 100%;
          font-family: "Segoe UI", "corbel", sans-serif;
          width: 100%;
        }

        .menu-list li button:hover {
          background-color: #3347ab;
          cursor: pointer;
          color: white;
        }

        .menu-list li button:focus {
          outline: none;
          background-color: #3347ab !important;
          font-weight: 600;
        }

        .menu-list li .active-menu {
          background-color: #3347ab !important;
          font-weight: 600;
          color: white;
        }

        .sub-menu-list {
          margin-left: 7px;
          display: none;
        }

        .hide-nav-item { display: none; }

        /* Nav Keys */
        #nav-dashboard { display: ${menu.dashboard}; }
        #nav-products { display: ${menu.products}; }
        #nav-stockin { display: ${menu.stockin}; }
        #nav-stockout { display: ${menu.stockout}; }
        #nav-invoice { display: ${menu.invoice}; }
        #nav-customers_accounts { display: ${menu.customers_accounts}; }
        #nav-receipts { display: ${menu.receipts}; }
        #nav-reports { display: ${menu.reports}; }
        #nav-utilities { display: ${menu.utilities}; }
        #nav-settings { display: ${menu.settings}; }
        #nav-help { display: ${menu.help}; }
      `}
      </style>
    </React.Fragment>
  )
}
